export default "<img\r\n  id=\"image\"\r\n  src=\"https://pbs.twimg.com/media/EelNQwaWoAAxx51?format=jpg\"\r\n  crossorigin=\"anonymous\"\r\n/>\r\n"